import { Card, Col, Row } from "antd";
import Title from "antd/lib/typography/Title";
import CompanyLogo from "components/CompanyLogo/CompanyLogo";
import { message } from "components/Messages/Messages";
import { isCompanyUser, useLoginContext } from "contexts/LoginContext/LoginContext";
import dayjs from "dayjs";
import { toCapitalCase } from "helpers/strings";
import { Event } from "interfaces/events";
import { useHistory } from "react-router-dom";
import EventStatusBadge from "./EventStatusBadge/EventStatusBadge";

interface Props {
  event: Event;
}

const EventCard: React.FC<Props> = ({ event }) => {
  const history = useHistory();
  const { currentUser } = useLoginContext();

  const openEvent = () => {
    if (!currentUser) {
      return message("error", "Du må logge inn eller registrere deg for å åpne arrangementer");
    }
    if (isCompanyUser(currentUser) && event.company.id !== currentUser.id) {
      return message("error", "Bedrifter kan kun åpne egne arrangementer");
    }
    return history.push(`/events/${event.id}/`);
  };

  return (
    <Col>
      <Card hoverable onClick={openEvent} style={{ backgroundColor: "white" }}>
        <EventStatusBadge eventId={event.id} />
        <CompanyLogo key={event.company.id} src={event.company.logo} companyId={event.company.id} size="20vh" />
        <Row style={{ padding: "1em 1em 0px", textAlign: "center" }} justify="center">
          <Title level={5} style={{ color: "rgb(5, 5, 5)" }}>
            {toCapitalCase(dayjs(event.start).format("dddd"))}
            <br />
            {dayjs(event.start).format("D. MMM")}
          </Title>
        </Row>
      </Card>
    </Col>
  );
};

export default EventCard;
